"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Reset = function Reset() {
  return _react["default"].createElement(_core.Global, {
    styles: {
      '*': {
        boxSizing: 'border-box'
      },
      body: {
        margin: '0'
      },
      'h1, h2, h3, h4, h5, h6': {
        margin: 0
      },
      small: {
        fontSize: '100%'
      },
      a: {
        textDecoration: 'none'
      },
      button: {
        border: 0,
        padding: 0,
        fontSize: '100%',
        backgroundColor: 'transparent'
      },
      p: {
        margin: 0
      }
    }
  });
};

var _default = Reset;
exports["default"] = _default;